import { useCallback, useEffect, useState } from "react";
import { api, mesajEroare } from "./api.js";
import { tr } from "./i18n.js";

/**
 * Supravegherea parcului: unde se strică ceva anormal de des.
 *
 * ECRANUL E O MATRICE, ca cea de drepturi: clienții pe rânduri, nivelurile pe
 * coloane, o bifă pe rând. Firma pune clientul într-o categorie — asta face
 * oricum zilnic —, în loc să completeze trei cifre pentru fiecare. Așa nu
 * ajunge nimeni pe o combinație pe care n-o mai înțelege nimeni peste un an,
 * iar numele nivelului ține loc de explicație.
 *
 * ÎN FIECARE CELULĂ SCRIE CÂTE ALARME AR SUNA la nivelul acela. Asta e ce
 * transformă o alegere făcută în orb într-una făcută văzând urmarea: nu mai
 * muți un client pe „Strict" ca să afli peste o lună că-ți sună de opt ori pe
 * săptămână. O alarmă care sună prea des nu e ignorată — e oprită, și atunci
 * se pierde și ce era folositor în ea.
 */

const NUMAR = (n) => (n === 0 ? "—" : String(n));

export default function Supraveghere({ eu }) {
  const [d, setD] = useState(null);
  const [tipare, setTipare] = useState([]);
  const [uzura, setUzura] = useState({ uzate: [], faraIstoric: [] });
  const [incarca, setIncarca] = useState(true);
  const [eroare, setEroare] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [lucreaza, setLucreaza] = useState("");
  const [bifati, setBifati] = useState([]);
  const [editat, setEditat] = useState(null);

  // Butoanele se citesc din MATRICE, nu dintr-o listă de roluri scrisă aici.
  const [poateSchimba, setPoateSchimba] = useState(eu.rol === "ADMIN_TENANT");

  const reincarca = useCallback(async () => {
    setIncarca(true);
    try {
      const [m, t, u] = await Promise.all([
        api.supraveghereMatrice(),
        api.supraveghereTipare().catch(() => []),
        api.supraveghereUzura().catch(() => ({ uzate: [], faraIstoric: [] })),
      ]);
      setD(m);
      setTipare(Array.isArray(t) ? t : []);
      setUzura(u ?? { uzate: [], faraIstoric: [] });
      setEroare("");
    } catch (e) {
      setEroare(mesajEroare(e));
    } finally {
      setIncarca(false);
    }
  }, []);

  useEffect(() => { reincarca(); }, [reincarca]);
  useEffect(() => {
    api.drepturileMele()
      .then((x) => setPoateSchimba((x?.supraveghere ?? []).includes("administrare")))
      .catch(() => {});
  }, []);

  async function fa(cheie, actiune, dupa) {
    setLucreaza(cheie); setEroare(""); setMesaj("");
    try {
      await actiune();
      if (dupa) dupa();
      await reincarca();
    } catch (e) {
      setEroare(mesajEroare(e));
    } finally {
      setLucreaza("");
    }
  }

  if (incarca && !d) return <div className="continut"><div className="gol">{tr("Se încarcă…")}</div></div>;
  if (!d) return <div className="continut"><div className="eroare">{eroare}</div></div>;

  const niveluri = d.niveluri;
  const totiBifati = bifati.length === d.clienti.length && d.clienti.length > 0;

  return (
    <div className="continut">
      <h2>{tr("Supravegherea parcului")}</h2>
      <p className="subtitlu">
        {tr("Unde se strică ceva mult mai des decât în restul parcului. Se compară piese de același fel, raportat la câte bucăți sunt montate — nu numărul brut de defecte, care spune mai ales cât de mare e clientul.")}
      </p>

      {eroare && <div className="eroare" role="alert">{eroare}</div>}
      {mesaj && <div className="mesaj">{mesaj}</div>}

      {/* ── Ce iese din rând acum ─────────────────────────────────────────── */}
      <div className="panou">
        <div className="panou-antet">
          {tr("Ce iese din rând acum")}
          {tipare.length > 0 && <span className="pastila pastila-rau"> {tipare.length}</span>}
        </div>
        <div className="panou-corp">
          {tipare.length === 0 ? (
            <div className="gol">
              {tr("Nimic. Peste tot se strică aproximativ la fel de des — ceea ce e o veste bună, nu o lipsă de date.")}
            </div>
          ) : (
            <div className="tabel-derulabil">
              <table className="tabel">
                <thead>
                  <tr>
                    <th>{tr("Ce")}</th>
                    <th>{tr("Unde")}</th>
                    <th className="num">{tr("Bucăți")}</th>
                    <th className="num">{tr("Defecte")}</th>
                    <th>{tr("Cât de ieșit din rând")}</th>
                  </tr>
                </thead>
                <tbody>
                  {tipare.map((t) => (
                    <tr key={`${t.clientId}|${t.locatieId}|${t.tipComponentaId}`}>
                      <td><strong>{t.tipComponenta}</strong></td>
                      <td>
                        {t.client}
                        <div className="subtitlu">{t.locatie}</div>
                      </td>
                      <td className="num">{t.bucati}</td>
                      <td className="num">
                        {t.defecte}
                        {t.inlocuiri > 0 && (
                          <div className="subtitlu">{tr("{0} înlocuiri", t.inlocuiri)}</div>
                        )}
                      </td>
                      <td>
                        {t.singurulLoc ? (
                          <span className="pastila pastila-rau">
                            {tr("singurul loc unde se strică")}
                          </span>
                        ) : (
                          <>
                            <strong>{tr("de {0}× peste restul parcului", t.deCateOri)}</strong>
                            <div className="subtitlu">
                              {tr("aici {0} defecte/bucată, în rest {1}", t.rata, t.rataParc)}
                            </div>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <p className="subtitlu">
            {tr("Aplicația arată TIPARUL, nu cauza. Dacă acumulatorii se ard des la un obiectiv, ea vede că se întâmplă — dacă sunt subdimensionați, dacă e supratensiune sau căldură, vede un om care se duce acolo.")}
          </p>
        </div>
      </div>

      {/* ── Uzura: piese care și-au depășit durata obișnuită ──────────────── */}
      <div className="panou">
        <div className="panou-antet">
          {tr("Piese care și-au depășit durata obișnuită")}
          {uzura.uzate.length > 0 && (
            <span className="pastila pastila-soft"> {uzura.uzate.length}</span>
          )}
        </div>
        <div className="panou-corp">
          <p className="subtitlu">
            {tr("Durata se măsoară din istoricul VOSTRU — câte luni au ținut până acum piesele de același fel. Nu e o predicție că se vor strica: e o listă de luat cu tine la vizita preventivă care oricum e programată, în loc de o deplasare de urgență sâmbătă seara.")}
          </p>

          {uzura.uzate.length > 0 && (
            <div className="tabel-derulabil">
              <table className="tabel">
                <thead>
                  <tr>
                    <th>{tr("Piesa")}</th>
                    <th>{tr("Unde")}</th>
                    <th className="num">{tr("Are")}</th>
                    <th className="num">{tr("Ține de obicei")}</th>
                    <th className="num">{tr("Din durata ei")}</th>
                    <th>{tr("Reper")}</th>
                  </tr>
                </thead>
                <tbody>
                  {uzura.uzate.map((u) => (
                    <tr key={u.echipamentId}>
                      <td>
                        <strong>{u.tipComponenta}</strong>
                        <div className="subtitlu">{u.eticheta}</div>
                      </td>
                      <td>
                        {u.client}
                        <div className="subtitlu">{u.locatie}</div>
                      </td>
                      <td className="num">{tr("{0} luni", u.luni)}</td>
                      <td className="num">{tr("{0} luni", u.medianaLuni)}</td>
                      <td className="num"><strong>{u.procent}%</strong></td>
                      <td className="subtitlu">
                        {u.reper === "client"
                          ? tr("istoricul acestui client, {0} înlocuiri", u.dinInlocuiri)
                          : tr("istoricul firmei, {0} înlocuiri", u.dinInlocuiri)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {uzura.faraIstoric.length > 0 && (
            <>
              <p className="subtitlu">
                {tr("Pe tipurile de mai jos nu se poate spune încă nimic — nu fiindcă ceva e stricat, ci fiindcă nu s-au adunat destule înlocuiri ca o medie să fie credibilă. Se completează singur, pe măsură ce se lucrează.")}
              </p>
              <div className="tabel-derulabil">
                <table className="tabel">
                  <thead>
                    <tr>
                      <th>{tr("Tip de piesă")}</th>
                      <th className="num">{tr("Înlocuiri adunate")}</th>
                      <th className="num">{tr("Bucăți montate")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uzura.faraIstoric.slice(0, 25).map((f) => (
                      <tr key={f.tipComponentaId}>
                        <td>{f.tipComponenta}</td>
                        <td className="num">{tr("{0} din {1}", f.are, f.iiTrebuie)}</td>
                        <td className="num">{f.bucatiMontate}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {uzura.faraIstoric.length > 25 && (
                <p className="subtitlu">
                  {tr("…și încă {0} tipuri.", uzura.faraIstoric.length - 25)}
                </p>
              )}
            </>
          )}

          {uzura.uzate.length === 0 && uzura.faraIstoric.length === 0 && (
            <div className="gol">{tr("Nicio piesă peste durata ei obișnuită.")}</div>
          )}
        </div>
      </div>

      {/* ── Nivelurile ───────────────────────────────────────────────────── */}
      <div className="panou">
        <div className="panou-antet">{tr("Nivelurile")}</div>
        <div className="panou-corp">
          <p className="subtitlu">
            {tr("Pragul spune CÂT DE anormal, minimul spune PE CÂTE DOVEZI — pe două bucăți montate orice raport iese uriaș —, iar perioada le încadrează pe amândouă. O schimbare aici se aplică la toți clienții de pe nivelul respectiv.")}
          </p>
          <div className="tabel-derulabil">
            <table className="tabel">
              <thead>
                <tr>
                  <th>{tr("Nivel")}</th>
                  <th className="num">{tr("Peste medie")}</th>
                  <th className="num">{tr("Defect minim")}</th>
                  <th className="num">{tr("Perioadă")}</th>
                  <th className="num">{tr("Ar suna, la toți")}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {niveluri.map((n) => {
                  const seEditeaza = editat?.id === n.id;
                  return (
                    <tr key={n.id}>
                      <td>
                        <strong>{n.denumire}</strong>
                        {n.esteImplicit && (
                          <div className="subtitlu">{tr("clienții noi intră aici")}</div>
                        )}
                      </td>
                      {n.esteOprit ? (
                        <td className="num" colSpan={3}>
                          <span className="subtitlu">{tr("nu alarmează nimic")}</span>
                        </td>
                      ) : seEditeaza ? (
                        <>
                          <td className="num">
                            <input type="number" step="0.5" min="1" max="20" value={editat.prag}
                              onChange={(e) => setEditat({ ...editat, prag: e.target.value })} />
                          </td>
                          <td className="num">
                            <input type="number" step="1" min="1" max="50" value={editat.defectMinim}
                              onChange={(e) => setEditat({ ...editat, defectMinim: e.target.value })} />
                          </td>
                          <td className="num">
                            <input type="number" step="1" min="1" max="60" value={editat.luniInapoi}
                              onChange={(e) => setEditat({ ...editat, luniInapoi: e.target.value })} />
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="num">{tr("{0}×", n.prag)}</td>
                          <td className="num">{n.defectMinim}</td>
                          <td className="num">{tr("{0} luni", n.luniInapoi)}</td>
                        </>
                      )}
                      <td className="num">{n.esteOprit ? "—" : NUMAR(n.alarmeDacaToti)}</td>
                      <td className="celula-actiuni">
                        {poateSchimba && !n.esteOprit && (seEditeaza ? (
                          <>
                            <button className="buton buton-mic" disabled={lucreaza === n.id}
                              onClick={() => fa(n.id, () => api.supraveghereSchimbaNivel(n.id, {
                                prag: Number(editat.prag),
                                defectMinim: Number(editat.defectMinim),
                                luniInapoi: Number(editat.luniInapoi),
                              }), () => { setEditat(null); setMesaj(tr("Nivelul s-a schimbat, la toți clienții de pe el.")); })}>
                              {tr("Salvez")}
                            </button>
                            <button className="buton buton-mic buton-discret"
                              onClick={() => setEditat(null)}>{tr("Renunț")}</button>
                          </>
                        ) : (
                          <button className="buton buton-mic buton-discret"
                            onClick={() => setEditat({
                              id: n.id, prag: n.prag, defectMinim: n.defectMinim, luniInapoi: n.luniInapoi,
                            })}>
                            {tr("Schimb cifrele")}
                          </button>
                        ))}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── Matricea ─────────────────────────────────────────────────────── */}
      <div className="panou">
        <div className="panou-antet">{tr("Clienții")}</div>
        <div className="panou-corp">
          <p className="subtitlu">
            {tr("În paranteze, câte alarme ar suna la nivelul acela. Se vede înainte de clic ce urmează, nu peste o lună.")}
          </p>

          {poateSchimba && bifati.length > 0 && (
            <div className="formular-linie">
              <div className="camp">
                <label>{tr("{0} clienți bifați — pune-i pe:", bifati.length)}</label>
                <div className="celula-actiuni">
                  {niveluri.map((n) => (
                    <button key={n.id} className="buton buton-mic" disabled={lucreaza === "muta"}
                      onClick={() => fa("muta", () => api.supraveghereMuta(bifati, n.id),
                        () => { setMesaj(tr("{0} clienți mutați pe nivelul {1}.", bifati.length, n.denumire)); setBifati([]); })}>
                      {n.denumire}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="tabel-derulabil">
            <table className="tabel">
              <thead>
                <tr>
                  {poateSchimba && (
                    <th className="num">
                      <input type="checkbox" aria-label={tr("bifează toți clienții")}
                        checked={totiBifati}
                        onChange={(e) => setBifati(e.target.checked ? d.clienti.map((c) => c.id) : [])} />
                    </th>
                  )}
                  <th>{tr("Client")}</th>
                  {niveluri.map((n) => <th key={n.id} className="num">{n.denumire}</th>)}
                </tr>
              </thead>
              <tbody>
                {d.clienti.map((c) => (
                  <tr key={c.id}>
                    {poateSchimba && (
                      <td className="num">
                        <input type="checkbox" aria-label={tr("bifează {0}", c.denumire)}
                          checked={bifati.includes(c.id)}
                          onChange={(e) => setBifati(e.target.checked
                            ? [...bifati, c.id] : bifati.filter((x) => x !== c.id))} />
                      </td>
                    )}
                    <td>
                      {c.denumire}
                      {c.urmeazaImplicitul && (
                        <div className="subtitlu">{tr("urmează nivelul implicit")}</div>
                      )}
                    </td>
                    {niveluri.map((n) => (
                      <td key={n.id} className="num">
                        <input
                          type="radio" name={`nivel-${c.id}`}
                          aria-label={tr("{0} pe nivelul {1}", c.denumire, n.denumire)}
                          checked={c.nivelId === n.id}
                          disabled={!poateSchimba || lucreaza === c.id}
                          onChange={() => fa(c.id, () => api.supraveghereMuta([c.id], n.id))}
                        />
                        {!n.esteOprit && (
                          <div className="subtitlu">{NUMAR(c.alarme[n.id])}</div>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
